import type { SignupRole } from "../../../types/types";

export const MIN_AGE_TEEN = 14;
export const MAX_AGE_TEEN = 19;
export const MIN_AGE_ADULT = 18;
export const MAX_AGE_ADULT = 120;

export const signupRoleOptions: Array<{ value: SignupRole; title: string; description: string }> = [
  {
    value: "TEEN",
    title: "Teen",
    description: "Ages 14-19 looking for local gigs and volunteer opportunities.",
  },
  {
    value: "ADULT",
    title: "Adult",
    description: "Parents, guardians, homeowners, and businesses posting gigs or managing teen access.",
  },
];
